import gql from 'graphql-tag';

export default gql`
  mutation resumeCredential($channelId: UUID!, $mapId: String!) {
    resumeCredential(channelId: $channelId, mapId: $mapId)
  }
`;
